import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Card from "./Card";
import GithubContributions from "./sections/GithubContributions";
import styles from "./Home.module.css";
import { ArrowUpRight, Github, Linkedin } from "lucide-react";

const weatherDescriptions = { 0: "Sunny", 1: "Cloudy", 2: "Cloudy", 3: "Cloudy", 45: "Fog", 48: "Fog", 51: "Drizzle", 53: "Drizzle", 55: "Drizzle", 61: "Rain", 63: "Rain", 65: "Rain", 80: "Showers", 81: "Showers", 82: "Showers", 95: "Storm" };

export default function Home({ projects = [] }) {
  const [localTime, setLocalTime] = useState("");
  const [weather, setWeather] = useState({ temp: null, label: "Loading" });
  const projectCount = Array.isArray(projects) ? projects.length : 0;

  useEffect(() => {
    const update = () => setLocalTime(new Intl.DateTimeFormat("en-NZ", { timeZone: "Pacific/Auckland", weekday: "short", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit", hour12: false }).format(new Date()));
    update(); const timer = setInterval(update, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let active = true;
    fetch("https://api.open-meteo.com/v1/forecast?latitude=-36.85&longitude=174.76&current_weather=true&timezone=Pacific/Auckland")
      .then((res) => res.json()).then((data) => { if (active) { const current = data.current_weather || {}; setWeather({ temp: current.temperature ?? null, label: weatherDescriptions[current.weathercode] || "Auckland" }); } }).catch(() => { });
    return () => { active = false; };
  }, []);

  return <div className={styles.layout}>
    <div className={styles.topRow}>
      <Card extra={styles.introCard} style={{ flex: 4.2 }}>
        <h1>Hi, here&apos;s UZhiShi.</h1>
        <p className={styles.introText}>Software engineer · Machine learning · Data analytics</p>
      </Card>
      <Card extra={styles.socialCard} style={{ flex: 1.2 }}>
        <a href="https://github.com/DannyCui-2016" target="_blank" rel="noopener noreferrer" title="Danny on GitHub" aria-label="Danny on GitHub"><Github size={18} /><span>DANNY</span></a>
        <a href="https://github.com/KChoi0720" target="_blank" rel="noopener noreferrer" title="Jiping on GitHub" aria-label="Jiping on GitHub"><Github size={18} /><span>JIPING</span></a>
        <a href="https://www.linkedin.com/in/kevinchoi0720/" target="_blank" rel="noopener noreferrer" title="LinkedIn" aria-label="LinkedIn"><Linkedin size={18} /><span>JIPING</span></a>
      </Card>
    </div>

    <div className={styles.infoRow}>
      <Card extra={styles.timeCard}>
        <p>AUCKLAND TIME</p>
        <strong>{localTime}</strong>
      </Card>
      <Card extra={styles.weatherCard}>
        <p>WEATHER</p>
        <div className={styles.weatherValue}>
          <strong>{weather.temp !== null ? Math.round(weather.temp) + "°C" : "--"}</strong>
          <span>{weather.label}</span>
        </div>
      </Card>
      <Card extra={styles.projectCard}>
        <p>PROJECTS</p>
        <div className={styles.projectValue}>
          <strong>{projectCount}</strong>
          <Link to="/projects" className={styles.projectsLink} aria-label="Open projects">
            <ArrowUpRight size={17} />
          </Link>
        </div>
      </Card>
    </div>

    <Card extra={styles.githubCard}><GithubContributions /></Card>
  </div>;
}
